const video = document.querySelector(".video");
const progressBar = document.querySelector(".progress-bar");
const progressBarLine = document.querySelector(".progress-bar-line");
const controls = document.querySelector(".controls");
// const muteButton = document.querySelector(".mute-button");
const fullscreenButton = document.querySelector(".fullscreen-button");
const downloadButton = document.querySelector(".download-button");
const playButton = document.querySelector(".play-button");
const feather = document.querySelector(".feather");

const thumbnailImage = document.querySelector(".progress-bar img");

let completeUpdate = false;
function updatePage() {
  if (!completeUpdate) {
    console.log("Not updating page");
    return;
  }
  completeUpdate = false;
  console.log("Updating page");
  window.location.reload();
}
// updatePage();

// window.addEventListener("message", (event) => {
//   console.log("Received message:", event.data);
// });

let mouseDown = false;
let timeout = null;

function togglePlayPause() {
  if (video.paused || video.ended) {
    playButton.style.display = "none";
    video.play();
  } else {
    playButton.style.display = "block";
    video.pause();
  }
}

function progressBarUpdate() {
  const progressBarOffset = 5 + (video.currentTime / video.duration) * 90;
  progressBarLine.style.left = progressBarOffset + "%";
}

function progressScrub(e) {
  const scrubTime = (e.offsetX / progressBar.offsetWidth) * video.duration;
  video.currentTime = scrubTime;
}

function hideControls() {
  controls.style.opacity = 0;
  controls.style.pointerEvents = "none";
}
function showControls() {
  controls.style.opacity = 1;
  controls.style.pointerEvents = "auto";
}

video.addEventListener("click", (event) => {
  togglePlayPause();

  if (timeout) {
    clearTimeout(timeout);
  }

  showControls();

  timeout = setTimeout(() => {
    hideControls();
  }, 2000);
});
video.addEventListener("timeupdate", progressBarUpdate);

playButton.addEventListener("click", (event) => {
  togglePlayPause();
});

// muteButton.addEventListener("click", (event) => {
//   if (video.muted) {
//     video.muted = false;
//   } else {
//     video.muted = true;
//   }

//   muteButton.classList.toggle("muted", video.muted);
// });

fullscreenButton.addEventListener("click", (event) => {
  if (document.fullscreenElement) {
    document.exitFullscreen();
  } else {
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen();
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen();
    }
  }
});

progressBar.addEventListener("click", (event) => {
  if (timeout) {
    clearTimeout(timeout);
  }

  showControls();

  progressScrub(event);

  timeout = setTimeout(() => {
    hideControls();
  }, 2000);
});
progressBar.addEventListener("touchstart", (e) => {
  mouseDown = true;
  progressScrub(e);
});
progressBar.addEventListener("touchend", () => {
  mouseDown = false;
});
progressBar.addEventListener("touchmove", (e) => {
  if (mouseDown) {
    progressScrub(e);
  }
});

downloadButton.addEventListener("click", () => {
  const hrefLink = downloadButton.getAttribute("data-link");
  const videoTitle = downloadButton.getAttribute("data-title");
  // const videoPoster = video.getAttribute("poster").src;
  // const thumbnailSource = thumbnailImage.getAttribute("src");
  // console.log("Download button clicked:", hrefLink, videoTitle);
  const message = `video_download_clicked:${hrefLink}:${videoTitle}`;
  console.log(message);
  channel1.postMessage(message);
});

const completeButton = document.getElementById("complete-button");
const completeModal = document.querySelector(".complete-modal");
const closeModalButton = document.querySelector(".close-modal-button");

if (completeButton) {
  completeButton.addEventListener("click", async (event) => {
    const videoId = event.currentTarget.dataset.videoid;
    const courseId = localStorage.getItem("currentC");
    console.log(localStorage.getItem("currentC"));
    try {
      const response = await fetch(
        `/apps/potato/complete?cid=${courseId}&vid=${videoId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            video_id: videoId,
          }),
        },
      );

      if (response.ok) {
        if (!completeModal.classList.contains("hidden")) return;
        completeModal.classList.toggle("hidden");
        const completeButtonInner = completeButton.querySelector("button");
        completeButtonInner.disabled = true;
        completeButtonInner.innerText = "Completed!";
        completeUpdate = true;
      } else {
        if (!completeModal.classList.contains("hidden")) return;
        completeModal.classList.toggle("hidden");
        const pTag = completeModal.querySelector("p");
        pTag.innerHTML =
          "There was an error marking video as complete. Please try again.";
        setTimeout(() => {
          if (!completeModal.classList.contains("hidden")) return;
          completeModal.classList.toggle("hidden");
        }, 3000);
      }
    } catch (error) {
      console.error("Error fetching video data:", error);
      const pTag = completeModal.querySelector("p");
      pTag.innerHTML =
        "There was an error marking video as complete. Please try again.";
      setTimeout(() => {
        if (!completeModal.classList.contains("hidden")) return;
        completeModal.classList.toggle("hidden");
      }, 3000);
    }
  });
}

if (closeModalButton) {
  closeModalButton.addEventListener("click", () => {
    if (completeModal.classList.contains("hidden")) return;
    completeModal.classList.toggle("hidden");
  });
}
